var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageLengthPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.765,
    height: 9.01,
    viewBox: "0 0 12.765 9.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83690",
    "data-name": "Path 83690",
    d: "M6,12H17.265M6,15.755h6.258M6,19.51h9.387",
    transform: "translate(-5.25 -11.25)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLengthPurpleIcon);
export default __webpack_public_path__ + "static/media/message-length-purple-icon.fe28da25f40bdf85226767981c8ec1b6.svg";
export { ForwardRef as ReactComponent };